'use strict';

module.exports = /* @ngInject */ function($scope, $http, apiConfig, feUniteCatalogService) {
	$scope.catalogData = null;

	$scope.init = function(customer, supplier) {
		loadData(customer, supplier)
	};

	/**
	 * load unite search result from api
	 */
	function loadData(customer, supplier) {
		feUniteCatalogService.getCatalogs.get({customer: customer, supplier: supplier}).$promise.then(function (data){
				$scope.catalogData = data.members;
		})
	}

	/**
	 * Opens the catalog article list with dojo
	 * @param catalogId
	 */
	$scope.openCatalog = function(catalogId){
		window.openContent('catalog/catalog_show_unite.htm&CATALOG_ID=' + catalogId);
	};

	/**
	 * Opens the detail page of a given supplier with dojo
	 * @param catalogId
	 * @param supplierId
	 */
	$scope.openSupplier = function(catalogId, supplierId){
		window.openContent('catalog/supplier_show.htm&VS_FIRMID=' + supplierId +'&CATALOGID=' + catalogId);
	};

}
